export const LOAD_DASHBOARDS = "LOAD_DASHBOARDS";
export const LOAD_DASHBOARDS_SUCCESS = "LOAD_DASHBOARDS_SUCCESS";
export const LOAD_DASHBOARDS_ERROR = "LOAD_DASHBOARDS_ERROR";
